module.exports = __webpack_public_path__ + "static/media/Idea.5d14dc05.jpg";